import { AxiosRequestConfig } from "axios";
import {
  LoggedInUserNotFlatResponse,
  LoggedInUserPayload,
  LoggedInUserResponseSchema,
} from "./contracts";
import { getLoggedInUserEndpoint } from "./endpoints";
import { http } from "@/services";

export const getUsers = (
  { email }: LoggedInUserPayload,
  config?: AxiosRequestConfig,
  isFlatResponse?: boolean,
) =>
  http.get<LoggedInUserNotFlatResponse>(
    getLoggedInUserEndpoint,
    { email },
    config,
    undefined,
    LoggedInUserResponseSchema,
    isFlatResponse,
  );
